import MLayout from "@/layout/M";
import userrouter from "./user";
const routes = [
  {
    path: "/",
    name: "index",
    component: MLayout,
    children: [
      {
        path: "",
        redirect: "index",
      },
      {
        path: "index",
        name: "index",
        component: (resolve) => require(["pages/mobile/index.vue"], resolve),
        meta: { showLeftMenu: false, requiresAuth: false },
      },

      {
        path: "login",
        name: "login",
        component: (resolve) => require(["pages/mobile/login"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
          guestOnly: true,
        },
      },
      {
        path: "forget",
        name: "forget",
        component: (resolve) => require(["pages/mobile/forget"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
          guestOnly: true,
        },
      },
      {
        path: "register",
        name: "register",
        component: (resolve) => require(["pages/mobile/register"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
          guestOnly: true,
        },
      },
      {
        path: "lists",
        name: "lists",
        component: (resolve) => require(["pages/mobile/lists/index"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
        },
      },
      {
        path: "detail/:id",
        name: "detail",
        component: (resolve) => require(["pages/mobile/lists/detail"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
        },
      },
      {
        path: "book_lists",
        name: "book_lists",
        component: (resolve) => require(["pages/mobile/book/lists"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
        },
      },
      {
        path: "book_detail/:id",
        name: "book_detail",
        component: (resolve) => require(["pages/mobile/book/detail"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
        },
      },
      {
        path: "cart",
        name: "cart",
        component: (resolve) => require(["pages/mobile/cart"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: true,
        },
      },

      {
        path: "orders/detail/:id",
        name: "ordersDetail",
        component: (resolve) => require(["pages/mobile/orders/detail"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: true,
        },
      },
      ...userrouter,
    ],
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/m/index.js